import PlaceholderPlantImage from '@/assets/placeholder-plant.jpg';

export const getImageUrl = (input: string | undefined): string => {
  return input || PlaceholderPlantImage;
};
